import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  // Don't throw — let the UI surface a friendly "set up your env" banner.
  console.warn('[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing.');
}

export const supabase = createClient(url ?? 'http://placeholder', anon ?? 'placeholder', {
  auth: { persistSession: true, autoRefreshToken: true, storageKey: 'hanta-map-auth' },
  global: { headers: { 'x-client-info': 'hantavirusmap.io' } },
});

export const supabaseConfigured = Boolean(url && anon);
